import React, { Component } from 'react';
import { bool, func, shape, string } from 'prop-types';
import { connect } from 'react-redux';

import { initializeEreader } from 'PipeRouter';

import CSS from './styles.scss';

class VSReader extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isInitialized: false
    };

    console.timeEnd('eReader#init')
    console.time('VSReader#init')
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const { ebook } = nextProps;
    const { vbid, cfi, start, stop } = ebook;
    const { isInitialized } = prevState;
  
    if (!cfi) {
      return null;
    }
  
    let createObject = {
      vbid,
      el: 'vs-reader',
      url: start && stop ?
        `?cfi=/${cfi}!,/${start},/${stop}` :
        `/cfi/${cfi}`,
    };
  
    if (!isInitialized) {
      console.timeEnd('VSReader#init')
      return {
        isInitialized: true,
        createObject: createObject,
      };
    }
  
    return null;
  }
  
  componentDidUpdate(prevProps, prevState) {
    const { ebook, initializeEreader } = this.props;
    const { isInitialized, createObject } = this.state;
  
    if (!isInitialized) {
      return;
    }
  
    if (createObject) {
      initializeEreader(createObject);
      this.setState({ createObject: null });
    }
  }

  render() {
    const { notifications: { createPageViewerFail, isLoading }} = this.props;

    return (
      <div id="vs-reader" className={`${CSS['vsContainer']} ${(createPageViewerFail || isLoading) ? CSS['hide'] : ''}`}/>
    );
  }
}

VSReader.propTypes = {
  initializeEreader: func,
  ebook: shape({
    vbid: string,
    cfi: string,
    begin: string,
    end: string
  }),
  notifications: shape({
    createPageViewerFail: bool,
    isLoading: bool
  })
};


function mapStateToProps(state) {
  const { notifications, reader } = state;

  return {
    ebook: reader.ebook,
    notifications
  };
}

export default connect(mapStateToProps, {
  initializeEreader
})(VSReader);
